import React from 'react';
import ReactDOM from 'react-dom/client';

// App
import App from './App';

// Axios
import axios from 'axios';

// Styles
import './index.css';

// MSAL
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';
import { MsalProvider } from '@azure/msal-react';

axios.defaults.baseURL = 'https://datavision.compumed.edu';

const msalInstance = new PublicClientApplication(msalConfig);

msalInstance
	.initialize()
	.then(() => {
		const root = ReactDOM.createRoot(
			document.getElementById('root') as HTMLElement
		);

		root.render(
			<React.StrictMode>
				{/* <BrowserRouter> */}
				<MsalProvider instance={msalInstance}>
					<App />
				</MsalProvider>
				{/* </BrowserRouter> */}
			</React.StrictMode>
		);
	})
	.catch((err) => {
		console.error('MSAL initialization error', err);
	});
